/**
 * Created by netre on 27.06.2017.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import cx from 'classnames';
import { lockDoorsClick } from '../Sidebar/actions';
import {
  clearTooltip, holdDown, lockDoorsResult, resetDeviceLockDoors,
  setTooltip,
} from '../../sagas/devices/actions';

import { isRecentAction } from '../../utils/helpers';

@connect(
  state => ({
    centralLockOn: state.devices.currentDeviceStats.centralLockOn,
    deviceId: state.devices.currentDevice.id,
    lockDoorsState: state.devices.lockDoorsState[state.devices.currentDevice.id] || 0,
  }),
  dispatch => ({
    lockDoors({ deviceId, on }) {
      return dispatch(lockDoorsClick({ deviceId, on }));
    },
    resetLockDoors({ deviceId }) {
      return dispatch(resetDeviceLockDoors({ deviceId }));
    },
    lockDoorsResult({ result, on }) {
      return dispatch(lockDoorsResult({ result, on }));
    },
    setTooltip({ type }) {
      return dispatch(setTooltip({ type }));
    },
    clearTooltip() {
      return dispatch(clearTooltip());
    },
  }))
@translate(['dashboard-sidebar'], { wait: true })
export class LockDoors extends PureComponent {

  clickHandler = (e) => {
    e.preventDefault();
    clearInterval(this.animationInterval);
  };
  mouseDownHandler = (e) => {
    const { handleAnimationState, lockDoors } = this.props;
    e.preventDefault();

    handleAnimationState(true);
    this.progress = 0;

    this.animationInterval = setInterval(() => {
      this.progress += 1;
      if (this.progress > 99) {
        this.progress = -1;
        clearInterval(this.animationInterval);
        lockDoors({
          deviceId: this.props.deviceId,
          on: this.props.centralLockOn,
        });
        handleAnimationState(false);
      }
    }, 3000 / 100);

    this.showHoldTooltip();
  };
  mouseUpHandler = (e) => {
    e.preventDefault();
    this.hideHoldTooltip();
    clearInterval(this.animationInterval);
    this.props.handleAnimationState(false);
  };

  showHoldTooltip = () => {
    this.props.setTooltip({
      type: holdDown,
    });
  };
  hideHoldTooltip = () => {
    if (this.progress <= 99 && this.progress !== -1) {
      this.hideTooltip(0);
      this.progress = 0;
    }
  };
  hideTooltip = (delay) => {
    setTimeout(() => {
      this.props.clearTooltip();
    }, delay);
  };

  render() {
    const { t, centralLockOn, quadratic } = this.props;
    const disabled = isRecentAction(this.props.lockDoorsState);

    const containerClass = cx('control-panel__button', { 'control-panel__button_shape_quadratic': quadratic });
    const buttonClass = cx('control-button', 'control-button_type_doors', { 'control-button_state_active': !centralLockOn, 'control-button_shape_quadratic': quadratic });

    return (

      <div className={containerClass}>
        <button
          className={buttonClass}
          disabled={disabled}
          onMouseDown={this.mouseDownHandler}
          onMouseUp={this.mouseUpHandler}
          onClick={this.clickHandler}
        >
          <span className="control-button__icon" />
          <span className="control-button__text">{centralLockOn ? t('dashboard-sidebar:openDoors') : t('dashboard-sidebar:closeDoors')}</span>
        </button>
      </div>
    );
  }
}

LockDoors.PropTypes = {
  animationInterval: PropTypes.number,
  setAnimating: PropTypes.func.isRequired,
  setAnimationInterval: PropTypes.func.isRequired,
  handleAnimationState: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DeviceControl/LockDoors.js